import {
  Box,
  Button,
  Container,
  FormControl,
  IconButton,
  InputBase,
  MenuItem,
  Select,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
// import EvolutionCard from '../../../Components/EvolutionCard'
// import WTypography from '../../../Components/whiteTypography'
// import { makeGetRequest } from '../../../utils/api'
// import urls from '../../../utils/urls'
import MesActifs from './MesActifs'
import MesPassifs from './MesPassifs'
import MonCashFlow from './MonCashFlow'
import RevenusDespense from './RevenusDespense'
import styled from '@emotion/styled'
import { makeGetRequest } from 'utils/api'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { setSitedevise } from 'reduxLib/slices/deviseSlice'

import dayjs from 'dayjs'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import CustomButton from 'Components/CustomButton/CustomButton'
import { convertToMuiDate } from 'utils/helpers'
import { setAppStore } from 'reduxLib/slices/mainAppSlice'
import SettingsIcon from '@mui/icons-material/Settings'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import BackupTableIcon from '@mui/icons-material/BackupTable'
import InsertChartIcon from '@mui/icons-material/InsertChart'
import TableChartIcon from '@mui/icons-material/TableChart'
import EqualizerIcon from '@mui/icons-material/Equalizer'
import DonutSmallIcon from '@mui/icons-material/DonutSmall'
import ShowChartIcon from '@mui/icons-material/ShowChart'
import TableRowsIcon from '@mui/icons-material/TableRows'
import { Dropdown } from '@mui/base/Dropdown'
import { MenuButton as BaseMenuButton } from '@mui/base/MenuButton'
import { MenuItem as BaseMenuItem, menuItemClasses } from '@mui/base/MenuItem'
import { Menu } from '@mui/base/Menu'
import BarChartIcon from '@mui/icons-material/BarChart'
import { restAppStore } from 'reduxLib/slices/mainAppSlice'
import { get } from 'lodash'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// import { Button } from 'reactstrap'

// import BarChart from './RevenusDespense/BarChart'
// import DonutChart from './RevenusDespense/DonutChart'
// import Filters from './RevenusDespense/Filters'
// import OperationTable from './RevenusDespense/OperationTable'

function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

function DashboardDetail() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const siteDevise = useSelector((store) => store.devise)
  const getAppStore = useSelector((store) => store.appStore).appStore
  const user = useSelector((store) => store.user?.user)
  const [deviseList, setDeviseList] = useState([])

  const [selectDateType, setSelectDateType] = useState(getAppStore.type || 11)
  const [selectViewType, setSelectViewType] = useState('global')
  const [dateFrom, setDateFrom] = useState(null)
  const [dateTo, setDateTo] = useState(null)
  const [viewList, setViewList] = useState([])

  const params = useParams()
  const { slug } = params
  let query = useQuery()
  useEffect(() => {
    if (slug === 'mespassifs' || slug === 'mesactifs') {
      setViewList(passifsViewListType)
    } else {
      setViewList(viewListType)
    }
    dispatch(restAppStore({}))
    getDeviseList()
    // eslint-disable-next-line no-undef
    // deviseLlist.list = ''
  }, [])

  useEffect(() => {
    setDateFrom(null)
    setDateTo(null)

    if (query.get('type')) {
      query.set('type', selectDateType)
    } else {
      query.append('type', selectDateType)
    }
    if (selectDateType !== 3) {
      if (query.get('from_date')) {
        query.set('from_date', '')
      }
      if (query.get('to_date')) {
        query.set('to_date', '')
      }
      navigate('?' + query.toString())
    } else {
    }
  }, [selectDateType])
  const handelCustomFilter = () => {
    if (dateFrom && dateTo) {
      dispatch(
        setAppStore({
          fromDate: dateFrom.$d.toISOString().split('T')[0],
          toDate: dateTo.$d.toISOString().split('T')[0],
        }),
      )
    } else {
      return
    }
    if (query.get('type')) {
      query.set('type', selectDateType)
    } else {
      query.append('type', selectDateType)
    }
    // console.log(dateFrom.$d.toISOString().split('T')[0])
    if (query.get('from_date')) {
      query.set('from_date', dateFrom.$d.toISOString().split('T')[0])
    } else {
      query.append('from_date', dateFrom.$d.toISOString().split('T')[0])
    }
    if (query.get('to_date')) {
      query.set('to_date', dateTo.$d.toISOString().split('T')[0])
    } else {
      query.append('to_date', dateTo.$d.toISOString().split('T')[0])
    }
    navigate('?' + query.toString())
  }
  const getDeviseList = async () => {
    const response = await makeGetRequest('/api/Finance/devise-list/', {}, true)
    if (response.status === 200) {
      // setDeviseList({})
      setDeviseList(response.data)
    }
  }
  // LAP-733 (GE022) — labels now sourced from i18n
  const dateRageList = [
    { id: 1, label: t('dashboardDetail.today') },
    { id: 2, label: t('dashboardDetail.yesterday') },
    { id: 3, label: t('dashboardDetail.custom') },
    { id: 4, label: t('dashboardDetail.since1month') },
    { id: 5, label: t('dashboardDetail.since3months') },
    { id: 6, label: t('dashboardDetail.since6months') },
    { id: 7, label: t('dashboardDetail.since9months') },
    { id: 8, label: t('dashboardDetail.since12months') },
    { id: 9, label: t('dashboardDetail.since2years') },
    { id: 10, label: t('dashboardDetail.since5years') },
    { id: 11, label: t('dashboardDetail.all') },
  ]
  const viewListType = [
    { id: 1, value: 'Global', label: t('dashboardDetail.category') },
    { id: 2, value: 'Category', label: t('dashboardDetail.subcategory') },
    { id: 3, value: 'Accounts', label: t('dashboardDetail.accounts') },
  ]
  const passifsViewListType = [
    { id: 1, value: 'Global', label: t('dashboardDetail.global') },
    { id: 2, value: 'Asset class', label: t('dashboardDetail.assetClass') },
    { id: 3, value: 'Asset', label: t('dashboardDetail.asset') },
  ]
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '3px 26px 3px 5px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),

      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }))
  return (
    <Container maxWidth="xl">
      <Box display={'flex'} mr={10} mb={3}>
        <Box sx={{ maxWidth: 240 }}>
          <Box color={'white'}>{t('dashboardDetail.displayCurrency')}</Box>
          <FormControl fullWidth size="small">
            {/* <InputLabel>Devise</InputLabel> */}
            <Select
              value={siteDevise.devise.Code_iso}
              label="Devise"
              // onChange={()=>setDevise()}
              input={<BootstrapInput />}
            >
              {deviseList.map((e) => (
                <MenuItem key={e.id} value={e.Code_iso} onClick={() => dispatch(setSitedevise(e))}>
                  {e.Devise} - {e.Description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        {slug !== 'moncashflow' && (
          <Box sx={{ maxWidth: 240 }} ml={5}>
            <Box color={'white'}>{t('dashboardDetail.dateFunction')}</Box>
            <FormControl fullWidth size="small">
              {/* <InputLabel>Devise</InputLabel> */}
              <Select
                value={getAppStore.type || 11}
                // label="date"
                // onChange={()=>setDevise()}
                input={<BootstrapInput />}
              >
                {/* <MenuItem
                value={0}
                onClick={() => {
                  setSelectDateType(0)
                }}
              >
                Select date
              </MenuItem> */}
                {dateRageList.map((e) => (
                  <MenuItem
                    key={e.id}
                    value={e.id}
                    onClick={() => {
                      setSelectDateType(e.id)
                      dispatch(setAppStore({ type: e.id }))
                    }}
                  >
                    {e.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        {getAppStore.type === 3 && (
          <>
            <Box
              sx={{
                maxWidth: 280,
                '.MuiStack-root': {
                  pt: 0,
                  overflow: 'hidden',
                  '.MuiIconButton-root': { padding: 0 },
                },
              }}
              ml={5}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker', 'DatePicker']}>
                  <Box>
                    <Box color={'white'}>{t('dashboardDetail.from')}</Box>
                    <DatePicker
                      sx={{
                        '.MuiInputBase-root': {
                          bgcolor: 'white',
                          '& input': { padding: '4px 14px' },
                        },
                      }}
                      value={dateFrom}
                      onChange={(newValue) => setDateFrom(newValue)}
                    />
                  </Box>
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box
              sx={{
                maxWidth: 280,
                '.MuiStack-root': {
                  pt: 0,
                  overflow: 'hidden',
                  '.MuiIconButton-root': { padding: 0 },
                },
              }}
              ml={5}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker', 'DatePicker']}>
                  <Box>
                    <Box color={'white'}>{t('dashboardDetail.to')}</Box>
                    <DatePicker
                      sx={{
                        '.MuiInputBase-root': {
                          bgcolor: 'white',
                          '& input': { padding: '4px 14px' },
                        },
                      }}
                      value={dateTo}
                      onChange={(newValue) => setDateTo(newValue)}
                    />
                  </Box>
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box sx={{ maxWidth: 240 }} ml={5} mt={'23px'}>
              <Button variant="contained" size="small" onClick={handelCustomFilter}>
                {t('dashboardDetail.apply')}
              </Button>
            </Box>
          </>
        )}
      </Box>
      <Box display={'flex'} mr={1} mb={6}>
        {slug !== 'moncashflow' && (
          <Box sx={{ maxWidth: 240 }}>
            <FormControl fullWidth size="small">
              {/* <InputLabel>Devise</InputLabel> */}
              <Select
                value={getAppStore?.viewType || 'Global'}
                label="Devise"
                // onChange={()=>setDevise()}
                input={<BootstrapInput />}
              >
                {viewList.map((e) => (
                  <MenuItem
                    key={e.id}
                    value={e.value}
                    onClick={() => {
                      dispatch(setAppStore({ viewType: e.value }))
                    }}
                  >
                    {e.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        <Box ml="auto" display={'flex'} alignItems={'center'} gap={'10px'}>
          {slug !== 'moncashflow' && (
            <>
              <BackupTableIcon
                sx={{ color: getAppStore.legend ? '#a0d2d9' : 'white', cursor: 'pointer' }}
                onClick={() => dispatch(setAppStore({ legend: !getAppStore.legend }))}
              />
            </>
          )}
          {getAppStore?.expandChart ? (
            <CloseFullscreenIcon
              sx={{ color: 'white', cursor: 'pointer' }}
              onClick={() => dispatch(setAppStore({ expandChart: false }))}
            />
          ) : (
            <OpenInFullIcon
              sx={{ color: 'white', cursor: 'pointer' }}
              onClick={() => dispatch(setAppStore({ expandChart: true }))}
            />
          )}

          {/* <IconButton sx={{ bgcolor: 'unset' }}> */}
          {slug !== 'moncashflow' && (
            <>
              <Dropdown>
                <MenuButton>
                  <InsertChartIcon sx={{ color: 'white', cursor: 'pointer' }} />
                  {/* <ReorderIcon sx={{ color: 'gray' }} /> */}
                </MenuButton>
                <Menu slots={{ listbox: Listbox }}>
                  <MenuItemBase className={getAppStore.chart === 1 ? 'selected' : ''}>
                    <Box
                      display={'flex'}
                      alignItems={'center'}
                      onClick={() => dispatch(setAppStore({ chart: 1 }))}
                    >
                      <BarChartIcon sx={{ mr: 2, color: 'black', cursor: 'pointer' }} />
                      <Box sx={{ cursor: 'pointer' }}>{t('dashboardDetail.frequencyDistribution')}</Box>
                    </Box>
                  </MenuItemBase>
                  <MenuItemBase className={getAppStore.chart === 2 ? 'selected' : ''}>
                    <Box
                      display={'flex'}
                      alignItems={'center'}
                      onClick={() => dispatch(setAppStore({ chart: 2 }))}
                    >
                      <ShowChartIcon sx={{ mr: 2, color: 'black', cursor: 'pointer' }} />
                      <Box sx={{ cursor: 'pointer' }}>{t('dashboardDetail.evolution')}</Box>
                    </Box>
                  </MenuItemBase>
                  <MenuItemBase className={getAppStore.chart === 3 ? 'selected' : ''}>
                    <Box
                      display={'flex'}
                      alignItems={'center'}
                      onClick={() => dispatch(setAppStore({ chart: 3 }))}
                    >
                      <DonutSmallIcon sx={{ mr: 2, color: 'black', cursor: 'pointer' }} />
                      <Box sx={{ cursor: 'pointer' }}>{t('dashboardDetail.distribution')}</Box>
                    </Box>
                  </MenuItemBase>
                </Menu>
              </Dropdown>
              {/* </IconButton> */}
              <Box
                bgcolor={'white'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                padding={'2px 10px'}
                borderRadius={'4px'}
                gap={'10px'}
              >
                <TableChartIcon
                  sx={{
                    cursor: 'pointer',
                    color: '#3486c2',
                    border: getAppStore.table === 1 ? '1px solid' : '',
                  }}
                  onClick={() => dispatch(setAppStore({ table: 1 }))}
                />
                <EqualizerIcon
                  sx={{
                    cursor: 'pointer',
                    color: '#3486c2',
                    border: getAppStore.table === 2 ? '1px solid' : '',
                  }}
                  onClick={() => dispatch(setAppStore({ table: 2 }))}
                />
                <TableRowsIcon
                  sx={{
                    cursor: 'pointer',
                    color: '#3486c2',
                    border: getAppStore.table === 3 ? '1px solid' : '',
                  }}
                  onClick={() => dispatch(setAppStore({ table: 3 }))}
                />
              </Box>
            </>
          )}
        </Box>
      </Box>
      {(slug === 'D' || slug === 'R') && <RevenusDespense />}
      {slug === 'moncashflow' && <MonCashFlow />}
      {(slug === 'mesactifs' || slug === 'mespassifs') && <MesPassifs />}
      {/* {slug === 'mespassifs' && <MesPassifs />} */}
    </Container>
  )
}

export default DashboardDetail

const blue = {
  50: '#F0F7FF',
  100: '#C2E0FF',
  200: '#99CCF3',
  300: '#66B2FF',
  400: '#3399FF',
  500: '#007FFF',
  600: '#0072E6',
  700: '#0059B3',
  800: '#004C99',
  900: '#003A75',
}

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
}
const Listbox = styled('ul')(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 6px;
  margin: 12px 0;
  min-width: 200px;
  border-radius: 12px;
  overflow: auto;
  outline: 0px;
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  box-shadow: 0px 4px 6px ${
    theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.50)' : 'rgba(0,0,0, 0.05)'
  };
  z-index: 1;
  `,
)

const MenuItemBase = styled(BaseMenuItem)(
  ({ theme }) => `
  list-style: none;
  padding: 8px;
  border-radius: 8px;
  cursor: default;
  user-select: none;

  &:last-of-type {
    border-bottom: none;
  }

  &.${menuItemClasses.focusVisible} {
    outline: 3px solid ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    background-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[100]};
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  }

  &.${menuItemClasses.disabled} {
    color: ${theme.palette.mode === 'dark' ? grey[700] : grey[400]};
  }

  &:hover:not(.${menuItemClasses.disabled}) {
    background-color: ${theme.palette.mode === 'dark' ? blue[900] : blue[50]};
    color: ${theme.palette.mode === 'dark' ? blue[100] : blue[900]};
    
  }
  &.selected{
    background-color: #bed2e9;
  }
 
  `,
)

const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.5;
  // padding: 8px 16px;
  border-radius: 8px;
  color: white;
  transition: all 150ms ease;
  cursor: pointer;
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#ffffff66'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);

  &:active {
    background: ${theme.palette.mode === 'dark' ? grey[700] : grey[100]};
  }

  &:focus-visible {
    box-shadow: 0 0 0 4px ${theme.palette.mode === 'dark' ? blue[300] : blue[200]};
    outline: none;
  }
  `,
)
